const ConsoleLog = (props) =>{
    console.log("props", props);

    return (<></>);
}

export default ConsoleLog;